import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import apiClient from "../Config/apiConfig";
import { LineWave } from "react-loader-spinner";
const config = {
  BASE_URL: "https://admin.thezeeshangroup.com/",
};

const Testimonials = () => {
  const testimonialsSlider = {
    margin: 20,
    responsiveClass: true,
    nav: true,
    autoplay: true,
    loop: true,
    dots: false,
    smartSpeed: 800,
    autoplayTimeout: 3000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  };
  const [getTestimonialsData, setGetTestimonialsData] = useState([]);
  const [loader, setLoader] = useState(true);
  const testimonialsApi = async () => {
    try {
      const res = await apiClient.get(`api/testimonials`);
      setGetTestimonialsData(res.data);
      setLoader(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    testimonialsApi();
  }, []);
  return (
    <>
      <div className="title-bar-wrapper">
        <Container>
          <Row>
            <div className="title">
              <h1>Testimonials</h1>
            </div>
            <ul className="bread-crumb pull-right">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>-</li>
              <li>Testimonials</li>
            </ul>
          </Row>
        </Container>
      </div>
      <div className="testimonial-bg">
        <Container>
          {loader ? (
            <div className="d-flex justify-content-center">
              <LineWave
                height="250"
                width="150"
                color="#56b13d"
                ariaLabel="line-wave"
              />
            </div>
          ) : (
            (!getTestimonialsData || getTestimonialsData?.length === 0) ? (
              <h5 className="text-center">Testimonials are coming soon!</h5>
            ) : (<Row>
              <Col sm="12">
                <OwlCarousel
                  className="slider-items owl-carousel"
                  {...testimonialsSlider}
                >
                  {getTestimonialsData?.map((item, i) => {
                    let outlineStar = 5 - parseInt(item.star);
                    const getfullStarContent = stars => {
                      let fullStar = [];
                      for (let i = 0; i < item.star; i++) {
                        fullStar.push(<AiFillStar />);
                      }
                      return fullStar;
                    };
                    const getOutlineContent = stars => {
                      let outStar = [];
                      for (let i = 0; i < outlineStar; i++) {
                        outStar.push(<AiOutlineStar />);
                      }
                      return outStar;
                    };
                    return (
                      <div className="item">
                        <div className="testimonial">
                          <img
                            src={`${config.BASE_URL}uploads/testimonials/${item.profile_image}`}
                            alt={item.name}
                          />
                          <div className="star">
                            {getfullStarContent()}
                            {getOutlineContent()}
                          </div>
                          <p>{item.details}</p>
                        </div>
                        <div className="testimonial-author">
                          <span className="name">
                            <strong>{item.designation}</strong>
                            {item.name}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </OwlCarousel>
              </Col>
            </Row>)
          )}
        </Container>
      </div>
    </>
  );
};

export default Testimonials;
